import lodash from 'lodash'
import { useEffect, useRef, useState } from 'react'
import uuid from 'uuid'

import { useField } from '../../../../1stlog-ui/src/components/Field'
import { useForm } from '../../../../1stlog-ui/src/components/Form'
import useFilledOrErrorField from './useFilledOrErrorField'

const ContactExpander = (props) => {
  const { alwaysOpen = false } = props

  // used to force recheck
  const [key, setKey] = useState()
  const [showContact, setShowContact] = useField('showContact', {
    asState: true,
  })
  const prename = useFilledOrErrorField('prename')
  const surname = useFilledOrErrorField('surname')
  const phone1 = useFilledOrErrorField('phone1')
  const mail = useFilledOrErrorField('mail')
  const eori = useFilledOrErrorField('eori')
  const ustid = useFilledOrErrorField('ustid')
  const customerAddressHint = useFilledOrErrorField('customerAddressHint')

  const updateKey = () => setKey(uuid())

  const onFormErrors = ({ errors }) => {
    if (errors) {
      updateKey()
    }
  }

  const subscriber = useRef()
  const form = useForm()

  useEffect(() => {
    if (form) {
      subscriber.current = form.subscribe(onFormErrors, {
        errors: true,
      })
      updateKey()
    }

    return () => {
      if (subscriber.current) {
        subscriber.current()
      }
    }
  }, [form])

  // automatically expand contacts if any values are present
  useEffect(() => {
    const hasValues = lodash.some(
      [prename, surname, phone1, mail, eori, ustid, customerAddressHint],
      (v) => v && v !== '',
    )
    if (hasValues) {
      setTimeout(() => setShowContact(true), 0)
    }
  }, [prename, surname, phone1, mail, eori, ustid, customerAddressHint, key])

  useEffect(() => {
    if (alwaysOpen) {
      setTimeout(() => setShowContact(true), 0)
    }
  }, [alwaysOpen])

  return null
}

export default ContactExpander
